module.exports = __webpack_public_path__ + "media/images/metronic/social/twitter-dbc1cb6d1fa138436ad4cb1944629db5.png";